import {Box, Title} from "@mantine/core";
import classes from "./SettingsBox.module.css";
type Props = {
    title: string;
    children: React.ReactNode;
};

export function SettingsBox({title, children}: Props) {
    return (
        <Box className={classes.box}>
            <Title order={3} className={classes.title}>
                {title}
            </Title>
            <Box className={classes.content}>{children}</Box>
        </Box>
    );
}
